// Import our CSS
import "@/scss/app.scss";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */

import Alpine from "alpinejs";
import AOS from "aos";
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);

window.Alpine = Alpine;
Alpine.start();
// animation
AOS.init();

import './components/scroll-detection.js';
import "./components/popups.js";
import "./components/browser-resize.js";
import "./components/typing-text.js";
import "./components/freeform-csrf.js";